<form [formGroup]="formGroup">
  <mat-grid-list cols="2" rowHeight="75px">
    <mat-grid-tile>
      <label>Update Status</label>
      <mat-radio-group [formControlName]="controls.STATUS_OPTIONS" class="m-l-5"
                       [name]="statusStepRadioGroupName.CASE_STATUS_RADIO_GROUP"
                       (change)="onUpdateStatusRadioOption($event)">
        <mat-radio-button class="m-r-5" [value]="statusType.YES">Yes</mat-radio-button>
        <mat-radio-button class="m-r-5" [value]="statusType.NO">No</mat-radio-button>
      </mat-radio-group>
      <mat-icon *ngIf="formGroup.get(controls.STATUS_OPTIONS).value  === statusType.YES" class="info-icon"
                [matTooltip]="'Please click the UPDATE button to finish adding the status or manager'">
        help_outline
      </mat-icon>
    </mat-grid-tile>

    <mat-grid-tile>
      <label>Update Manager</label>
      <mat-radio-group [formControlName]="controls.MANAGER_OPTIONS" class="m-l-5"
                       [name]="statusStepRadioGroupName.CASE_MANAGER_RADIO_GROUP"
                       (change)="onUpdateManagerRadioOption($event)">
        <mat-radio-button class="m-r-5" [value]="statusType.YES">Yes</mat-radio-button>
        <mat-radio-button class="m-r-5" [value]="statusType.NO">No</mat-radio-button>
      </mat-radio-group>
      <mat-icon *ngIf="formGroup.get(controls.MANAGER_OPTIONS).value  === statusType.YES" class="info-icon"
                [matTooltip]="'Please click the UPDATE button to finish adding the status or manager'">
        help_outline
      </mat-icon>
    </mat-grid-tile>
  </mat-grid-list>


  <mat-grid-list cols="2" rowHeight="75px">
    <mat-grid-tile *ngIf="formGroup.get(controls.STATUS_OPTIONS).value  === statusType.YES">
      <mat-form-field>
        <mat-label>Case Status</mat-label>
        <mat-select [formControlName]="controls.CASE_STATUS">
          <mat-option *ngFor="let status of caseStatusLookupValues" [value]="status.name"
                      (onSelectionChange)="onCaseStatusSelected(status)">
            {{status.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Status')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>


    <!--------------------------------------->
    <!--Empty For Alignment for Dropdown-->
    <mat-grid-tile *ngIf="formGroup.get(controls.STATUS_OPTIONS).value  === statusType.NO ||
                                formGroup.get(controls.MANAGER_OPTIONS).value  === statusType.NO">
    </mat-grid-tile>
    <!--------------------------------------->

    <mat-grid-tile *ngIf="formGroup.get(controls.MANAGER_OPTIONS).value  === statusType.YES">
      <mat-form-field>
        <mat-label>Case Manager</mat-label>
        <mat-select [formControlName]="controls.CASE_MANAGER">
          <mat-option *ngFor="let manager of caseManagerLookupValues" [value]="manager.name"
                      (onSelectionChange)="onCaseManagerSelected(manager)">
            {{manager.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-icon [matTooltip]="getInfoTooltip('Manager')" class="info-icon">help_outline</mat-icon>
    </mat-grid-tile>


    <mat-grid-tile *ngIf="formGroup.get(controls.STATUS_OPTIONS).value  === statusType.YES">
      <mat-form-field>
        <mat-label>Case Status Start Date</mat-label>
        <input [formControlName]="controls.CASE_STATUS_START_DATE"
               [matDatepicker]="caseStatusDatePicker" matInput
               [min]="formGroup.controls.caseStatusMinStartDateFormControl.value">
        <mat-datepicker-toggle [for]="caseStatusDatePicker" matIconSuffix>
        </mat-datepicker-toggle>
        <mat-datepicker #caseStatusDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Case Status Start Date')">help_outline
      </mat-icon>
    </mat-grid-tile>


    <!--------------------------------------->
    <!--Empty For Alignment Date Picker-->
    <mat-grid-tile *ngIf="formGroup.get(controls.STATUS_OPTIONS).value  === statusType.NO ||
                                formGroup.get(controls.MANAGER_OPTIONS).value  === statusType.NO">
    </mat-grid-tile>
    <!--------------------------------------->

    <mat-grid-tile *ngIf="formGroup.get(controls.MANAGER_OPTIONS).value  === statusType.YES">
      <mat-form-field>
        <mat-label>Case Manager Start Date</mat-label>
        <input [formControlName]="controls.CASE_MANAGER_START_DATE"
               [matDatepicker]="caseManagerDatePicker" matInput
               [min]="formGroup.controls.caseManagerMinStartDateStartDateFormControl.value">
        <mat-datepicker-toggle [for]="caseManagerDatePicker" matIconSuffix>
        </mat-datepicker-toggle>
        <mat-datepicker #caseManagerDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Case Manager Start Date')">help_outline
      </mat-icon>
    </mat-grid-tile>

    <mat-grid-tile *ngIf="formGroup.get(controls.STATUS_OPTIONS).value  === statusType.YES">
      <button mat-raised-button color="primary" (click)="onUpdateCaseStatusHistory()">Update Status</button>
    </mat-grid-tile>

    <!--------------------------------------->
    <!--Empty For Alignment Button-->
    <mat-grid-tile *ngIf="formGroup.get(controls.STATUS_OPTIONS).value  === statusType.NO ||
                                formGroup.get(controls.MANAGER_OPTIONS).value  === statusType.NO">
    </mat-grid-tile>
    <!--------------------------------------->

    <mat-grid-tile *ngIf="formGroup.get(controls.MANAGER_OPTIONS).value  === statusType.YES">
      <button mat-raised-button color="primary" (click)="onUpdateCaseManagerHistory()">Update Manager</button>
    </mat-grid-tile>

  </mat-grid-list>

  <!--------------------------------------->
  <!--History Section-->
  <!--------------------------------------->
  <mat-divider></mat-divider>

  <div style="width: 46%; float: left;">
    <div class="history-column">
      <div class="mat-primary-color m-t-15 m-b-15">
        <label class="history-label">Status History</label>
      </div>
      <div *ngFor="let caseStatus of caseStatusLinkDTOHistoryList" class="status-history-section">
        <div class="history-date-width">
          {{caseStatus?.historyDisplayString}}
        </div>
        <div class="trash-icon">
          <mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
                    (click)="onDeleteHistory(caseStatus)">
            delete
          </mat-icon>
        </div>
      </div>

      <ng-container *ngIf="caseStatusLinkDTOHistoryList && caseStatusLinkDTOHistoryList.length === 0">
        <p class="light-grey">Set the status of the case by updating the status using the controls above</p>
      </ng-container>

    </div>
  </div>

  <div style="width: 48%; float: right;padding-left: 25px;">
    <div class="history-column">
      <div class="mat-primary-color m-t-15 m-b-15">
        <label class="history-label">Manager History</label>
      </div>
      <div *ngFor="let caseManager of caseManagerLinkDTOHistoryList" class="status-history-section">
        <div class="history-date-width">
          {{caseManager?.historyDisplayString}}
        </div>
        <div class="trash-icon">
          <mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
                    (click)="onDeleteHistory(caseManager)">
            delete
          </mat-icon>
        </div>
      </div>

      <ng-container *ngIf="caseManagerLinkDTOHistoryList && caseManagerLinkDTOHistoryList.length === 0">
        <p class="light-grey">Set the manager for the case by updating the manager using the controls above</p>
      </ng-container>

    </div>
  </div>

  <div class="button-container">
    <button #finalStepBackButton mat-raised-button matStepperPrevious color="primary">Back</button>
    <button #finalStepClearButton mat-raised-button color="warn" (click)="resetStatusFormGroup()">Clear</button>
    <button #finalStepFinishButton mat-raised-button matStepperNext color="primary"
            [disabled]="!isFormValid || !isStepValid || !isAuthorised"
            (click)="saveCaseHospitalDTO()">
      <!-- Note:
            For Hospital Cases ONLY,
            CaseMedical: Text of this button to "SAVE".
            CaseFuneral: Text of this button to "FINISH".
      -->
      {{ type === caseType.Medical ? 'Save' : 'Finish'}}
      <ng-container *ngIf="!isAuthorised">
				<mat-icon class="info-icon" matTooltip="Only the claims team can add or edit cases">help_outline</mat-icon>
			</ng-container>
    </button>
    <button class="w-15" *ngIf="isCaseMedical" mat-raised-button matStepperNext color="primary"
						[disabled]="!isFormValid || !isStepValid || isCaseDateLessThanTodayDate || !isAuthorised"
						(click)="onDischarge()">
      Finish & Discharge...
			<ng-container *ngIf="isCaseDateLessThanTodayDate || !isAuthorised else showDefaultIcon">
				<mat-icon class="info-icon"
									[matTooltip]="isCaseDateLessThanTodayDate ? 'The case is already closed and therefore cannot be discharged' : 'Only the claims team can add or edit cases'">
					help_outline
				</mat-icon>
			</ng-container>
			
			<ng-template #showDefaultIcon>
				<ng-container [ngTemplateOutlet]="infoIcon"></ng-container>
			</ng-template>
    </button>
  </div>
</form>

<ng-template #infoIcon>
  <mat-icon *ngIf="!isStepValid"
            class="info-icon"
            [matTooltip]="!isCaseStatusAndCaseManagerEntryExists
                                ? 'Please ensure the case is associated with a status and a manager '
                                : isCaseStatusOrMangerOptionEnabled
                                ? 'Please click the UPDATE button to finish adding the status or manager'
                                : null">
    help_outline
  </mat-icon>
</ng-template>
